import { SummitVerbose } from '@lc/card/verbose/SummitVerbose';
import { decisionCardResolution } from '@lc/const/turnTypes';
import { controller_game } from '@lc/controller/game';
import { GameManager } from '@lc/interface/gameManager/types';
import { coinFlip } from '@lc/lib/gamestate_helper';
import { getPlayerStateWithId } from '@lc/lib/player_helper';

import { ai_decision } from './ai_decision';
import { ai_purchase } from './ai_purchase';

class AI_Summit {
	playSummitCard = async (gameManager: GameManager, cardId: number) => {
		const { gameState } = gameManager;
		const activePlayerId = gameState.activePlayerId;
		const aiState = getPlayerStateWithId(
			gameState.playerStateArray,
			activePlayerId
		);

		const card = SummitVerbose[cardId];

		const paymentObject = await ai_purchase.createPaymentObjectForCost(
			aiState,
			card.cost
		);

		// await getPaymentObjectForCardId()
		const botPlayerData = {
			playerId: gameState.activePlayerId,
			gameId: gameState.game_id_server,
			cardId,
			paymentObject,
		};

		if (!paymentObject.paymentPossible) {
			return;
		}

		await controller_game.playSummitCard(botPlayerData, gameManager);
		// controller_card.removeCard(aiState, cardId);
		// deleteCardChance(aiState, cardId); //SHOULD always be removed since it's in the playCard logic...

		if (gameState.turnType === decisionCardResolution) {
			ai_decision.chooseCardResolution(gameManager);
		}
	};

	playSummitHand = async (
		gameManager: GameManager,
		type: string = 'turn'
	) => {
		const { gameState } = gameManager;
		const activePlayerId = gameState.activePlayerId;
		const aiState = getPlayerStateWithId(
			gameState.playerStateArray,
			activePlayerId
		);

		if (aiState.summitCards.length <= 0) return;
		for (let i = 0; i < aiState.summitCards.length; i++) {
			if (coinFlip(1 / aiState.summitCards.length)) {
				// odds are we will play 1 card a turn
				console.log('AI playing summit card i: ' + i);
				console.log(aiState.summitCards);
				const cardId = aiState.summitCards[i];
				console.log('cardId: ' + cardId);
				const card = SummitVerbose[cardId];
				console.log('card');
				console.log(card);
				if (card.type === type) {
					await this.playSummitCard(gameManager, cardId);
				}
			}
		}
	};

	winterSummitTurn = async (gameManager: GameManager) => {
		const { gameState } = gameManager;
		const activePlayerId = gameState.activePlayerId;
		console.log('ai id: ' + activePlayerId);

		// await aiPlayHand(gameState, ticker);
		// await aiBuyFactory(gameState, ticker);
		// await aiDonation(gameState, ticker);

		await this.playSummitHand(gameManager, 'winter');

		const botPlayerData = {
			playerId: gameState.activePlayerId,
			gameId: gameState.game_id_server,
		};

		// ticker.unshift('Player ' + activePlayerId + ' ' + endTurn);
		await controller_game.advanceSummitResolution(
			botPlayerData,
			gameManager
		);
	};
}

export const ai_summit = new AI_Summit();
